module.exports = __webpack_public_path__ + "img/plus_black.8d2f7c4f.svg";